module.exports = __webpack_public_path__ + "img/141.d21a82fa.jpg";